import { AuthProvider } from 'Auth/context/auth.context'
import { oidcConfig } from 'Auth/shared/constants/auth'
import { ReactNode } from 'react'
import { Provider } from 'react-redux'
import { Links, Outlet, Scripts, ScrollRestoration } from 'react-router'
import { NavigationBridge } from 'shared/routing'
import store from 'shared/store/store'
import '../src/styles.css'

export function Layout({ children }: { children: ReactNode }) {
  return (
    <html lang="nb">
      <head>
        <meta charSet="utf-8" />
        {/* Redirect /portal → /portal/ before React boots — basename requires trailing slash */}
        <script
          dangerouslySetInnerHTML={{
            __html: `if(location.pathname==='/portal')location.replace('/portal/')`,
          }}
        />
        <link
          rel="icon"
          href="https://bbldthemesprod.blob.core.windows.net/theme/bbld/favicon.ico"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        {/*
          'unsafe-inline' is required for React Router framework mode: it injects
          an inline bootstrap/hydration script (<Scripts/>) that this meta CSP
          would otherwise block. A per-request nonce is the secure alternative
          but is impossible with a statically prerendered SPA shell. The proper
          production hardening is to drop this <meta> and have the server/CDN
          emit CSP with a nonce.
        */}
        <meta
          httpEquiv="Content-Security-Policy"
          content="
        script-src 'self' 'unsafe-inline' 'unsafe-eval' blob: https://www.googletagmanager.com https://maps.googleapis.com https://*.google-analytics.com https://*.cookie-script.com;
        style-src 'self' 'unsafe-inline' https://fonts.googleapis.com https://unpkg.com/react-day-picker@9.5.0/src/style.css https://bbldthemestest.blob.core.windows.net https://bbldthemesstage.blob.core.windows.net https://bbldthemesprod.blob.core.windows.net;
      font-src 'self' https://fonts.googleapis.com https://fonts.gstatic.com https://bbldthemestest.blob.core.windows.net https://bbldthemesstage.blob.core.windows.net https://bbldthemesprod.blob.core.windows.net;"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap"
          rel="stylesheet"
        />
        <script
          type="text/javascript"
          src={`${import.meta.env.BASE_URL}config/appconfig.js`}
        />
        <script
          type="text/javascript"
          src={`${import.meta.env.BASE_URL}config/clientId.js`}
        />
        <script
          type="text/javascript"
          src={`${import.meta.env.BASE_URL}config/bblCode.js`}
        />
        <Links />
        <title>Portalen</title>
      </head>
      <body>
        <noscript>You need to enable JavaScript to run this app.</noscript>
        <div id="root">{children}</div>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

export function HydrateFallback() {
  return null
}

// Root route: cross-cutting providers always mounted (store, auth) plus the
// imperative-navigation bridge. FeedbackProvider lives in the `app-chrome`
// layout route instead of here: it pulls in @bbl-digital/snorre-v2, which
// touches `document` at import. SPA mode prerenders THIS root module in Node at
// build time, so any browser-only import here crashes the build; route module
// components (app-chrome) are client-only and stripped from the server build.
// The data-fetching app chrome lives in `app-chrome` so the bare auth routes
// (logout/afterlogout/cleanup) bypass it, matching pre-framework behavior.
export default function Root() {
  return (
    <Provider store={store}>
      <AuthProvider {...oidcConfig}>
        <NavigationBridge />
        <Outlet />
      </AuthProvider>
    </Provider>
  )
}
